import { getPentagonAreaLines, normalizeCoordinate } from '../helpers';

const PentagonAreaLines = ({ duvalType }) =>
  getPentagonAreaLines(duvalType).map((l, index) => (
    <line
      key={`pentagon-area-line-${index}`}
      x1={`${50 + normalizeCoordinate(l.from[0])}%`}
      y1={`${50 + normalizeCoordinate(l.from[1])}%`}
      x2={`${50 + normalizeCoordinate(l.to[0])}%`}
      y2={`${50 + normalizeCoordinate(l.to[1])}%`}
      className={`area-lines area-lines-stroke`}
      strokeWidth={1}
      strokeOpacity={0.5}
    />
  ));

export default PentagonAreaLines;
